import { UntypedFormControl } from '@angular/forms';
import { isTenancyActive } from '../is-entity-active';
import {
  INVALID_TENANCY_STATUS_ERROR_KEY,
  TenancyStatusControlsMapping,
  isSelectionValid,
} from './tenancy-status.utils';

export function TenancyStatusGetColumnNamesFactory(columnId: number) {
  const validationParams = TenancyStatusControlsMapping[columnId] ?? {};
  return (control: UntypedFormControl) => isTenancyStatusValid(control, validationParams);
}

const isTenancyStatusValid = (control: UntypedFormControl, params?: any) => {
  // Only add the logic if the Tenant entity is disabled
  if (isTenancyActive()) return null;
  // Get parent control
  const parentCtrl = control.parent;
  const startDate = parentCtrl?.get(params.startDate)?.value ?? null;
  const endDate = parentCtrl?.get(params.endDate)?.value ?? null;
  const occupancyDate = parentCtrl?.get(params.occupancyDate)?.value ?? null;

  // Only run the validations if there is a current selection
  const isValid =
    control.value == null || control.value === '' || isSelectionValid(control.value, occupancyDate, startDate, endDate);

  return isValid ? null : { [INVALID_TENANCY_STATUS_ERROR_KEY]: true };
};
